/* Scent Amp "modes" LP: one Dark/Light finish shared by every section on the page.
   - Any element with [data-sa-finish-set="dark|light"] picks that finish.
   - Any element with [data-sa-finish-toggle] flips it.
   - The current finish lives on <html data-sa-finish="…">; CSS in sa-modes.css does the rest.
   - Sections that need JS (buy box variant, videos) listen for the 'sa:finish' event.
   - ?finish=light in the URL opens the page on the light finish. */
(function () {
  if (window.SAFinish) return;

  var root = document.documentElement;
  var FINISHES = ['dark', 'light'];

  function get() {
    return root.getAttribute('data-sa-finish') || root.getAttribute('data-sa-finish-default') || 'dark';
  }

  function syncControls(f) {
    document.querySelectorAll('[data-sa-finish-set]').forEach(function (el) {
      var on = el.getAttribute('data-sa-finish-set') === f;
      el.classList.toggle('is-active', on);
      if (el.matches('button, [role="radio"], [role="button"]')) {
        el.setAttribute(el.getAttribute('role') === 'radio' ? 'aria-checked' : 'aria-pressed', on ? 'true' : 'false');
      }
    });
  }

  function syncVideos(f) {
    document.querySelectorAll('video[data-sa-fin-video]').forEach(function (v) {
      var mine = v.getAttribute('data-sa-fin-video') === f;
      /* Only touch videos that are rendered at this breakpoint. */
      var shown = v.offsetParent !== null || v.getClientRects().length > 0;
      if (mine && shown) {
        if (v.preload === 'none') v.preload = 'auto';
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      } else {
        try { v.pause(); } catch (e) {}
      }
    });
  }

  function set(f, source) {
    if (FINISHES.indexOf(f) === -1) return;
    var changed = get() !== f || !root.hasAttribute('data-sa-finish');
    root.setAttribute('data-sa-finish', f);
    syncControls(f);
    syncVideos(f);
    if (changed) {
      document.dispatchEvent(new CustomEvent('sa:finish', { detail: { finish: f, source: source || null } }));
    }
  }

  function toggle(source) {
    set(get() === 'dark' ? 'light' : 'dark', source);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sa-finish-set], [data-sa-finish-toggle]');
    if (!t) return;
    if (t.closest('[data-sa-dial]') && t.hasAttribute('data-sa-dial-dragged')) {
      t.removeAttribute('data-sa-dial-dragged');
      return;
    }
    e.preventDefault();
    if (t.hasAttribute('data-sa-finish-toggle')) toggle(t);
    else set(t.getAttribute('data-sa-finish-set'), t);
  });

  /* Review cards: the product row links to the PDP. On this page it scrolls to the buy box
     instead (the buy box already follows the chosen finish). */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a.testimonial__product');
    if (!link) return;
    var target = document.getElementById('sa-buybox');
    if (!target) return;
    e.preventDefault();
    var y0 = window.pageYOffset;
    try { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (err) { target.scrollIntoView(); }
    /* If smooth scrolling never starts (background tab, some in-app browsers), jump instead. */
    setTimeout(function () { if (Math.abs(window.pageYOffset - y0) < 2) target.scrollIntoView({ block: 'start' }); }, 700);
  });

  /* Dial knob: drag (or swipe) left = dark, right = light; arrow keys do the same. */
  document.addEventListener('pointerdown', function (e) {
    var knob = e.target.closest('[data-sa-dial-knob]');
    if (!knob) return;
    var x0 = e.clientX;
    function up(ev) {
      document.removeEventListener('pointerup', up);
      document.removeEventListener('pointercancel', up);
      var dx = ev.clientX - x0;
      if (Math.abs(dx) > 12) {
        knob.setAttribute('data-sa-dial-dragged', '');
        set(dx < 0 ? 'dark' : 'light', knob);
        setTimeout(function () { knob.removeAttribute('data-sa-dial-dragged'); }, 400);
      }
    }
    document.addEventListener('pointerup', up);
    document.addEventListener('pointercancel', up);
  });
  document.addEventListener('keydown', function (e) {
    var knob = e.target.closest && e.target.closest('[data-sa-dial-knob]');
    if (!knob) return;
    if (e.key === 'ArrowLeft') { e.preventDefault(); set('dark', knob); }
    if (e.key === 'ArrowRight') { e.preventDefault(); set('light', knob); }
  });

  /* Story block reveal: copy fades in once, when the top 10% of its block enters the viewport.
     The observed element is the nearest [data-sa-reveal-root] (the whole block), not the copy.
     Copy stays visible if IntersectionObserver is missing or motion is reduced. */
  function armReveal() {
    var els = document.querySelectorAll('[data-sa-reveal]:not([data-sa-reveal-armed])');
    if (!els.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || reduce) return;
    els.forEach(function (el) {
      var target = el.closest('[data-sa-reveal-root]') || el;
      el.setAttribute('data-sa-reveal-armed', '');
      el.classList.add('is-armed');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            el.classList.add('is-revealed');
            io.disconnect();
          }
        });
      }, { threshold: 0.1 });
      io.observe(target);
    });
  }

  function init() {
    var f = null;
    try {
      var q = new URLSearchParams(window.location.search).get('finish');
      if (FINISHES.indexOf(q) !== -1) f = q;
    } catch (e) {}
    set(f || get(), 'init');
    armReveal();
  }

  window.SAFinish = { get: get, set: set, toggle: toggle };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.addEventListener('resize', function () { syncVideos(get()); });
  document.addEventListener('shopify:section:load', function () { syncControls(get()); syncVideos(get()); armReveal(); });
})();
